/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import { ReactNode } from 'react';
import { inter } from '@/components/mc/fonts';
import { SessionProvider } from 'next-auth/react';

import HeaderMC from '../HeaderMC';
import SkipLink, { MAIN_CONTENT_ID } from '@/components/common/skip-link';
import FooterMC from '../FooterMC';

import '../../../app/globals.css';
import './DefaultLayoutMC.css';

interface LayoutProps {
  children: ReactNode;
}

const DefaultLayoutMC = async ({ children }: LayoutProps) => {
  return (
    <html lang="en" className={`${inter.variable}`}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-mc">
        <SessionProvider session={null}>
          <link rel="shortcut icon" href="/mc/favicon.ico" />
          <div className="h-full flex flex-col justify-between">
            <div>
              <SkipLink />
              <HeaderMC />
              <main id={MAIN_CONTENT_ID} tabIndex={-1} className="outline-none">
                {children}
              </main>
            </div>
            <div>
              <FooterMC isAuthorized={false} />
            </div>
          </div>
        </SessionProvider>
      </body>
    </html>
  );
};

export default DefaultLayoutMC;
